module.exports = __webpack_public_path__ + "static/media/pii2.d9b7e864.jpg";